import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import TodoPage from "@/pages/TodoPage";
import ProtokollePage from "@/pages/ProtokollePage";
import TemperaturPage from "@/pages/TemperaturPage";
import ErhitzungPage from "@/pages/ErhitzungPage";
import WareneingangPage from "@/pages/WareneingangPage";
import VorfaellePage from "@/pages/VorfaellePage";
import DokumentePage from "@/pages/DokumentePage";
import SchulungenPage from "@/pages/SchulungenPage";
import SchulungPrint from "@/pages/SchulungPrint";
import EinstellungenPage from "@/pages/EinstellungenPage";
import RaeumePage from "@/pages/RaeumePage";
import BackfillPage from "@/pages/BackfillPage";
import ExportPage from "@/pages/ExportPage";
import { Loader2 } from "lucide-react";

function Protected({ children, bare }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-teal-500" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return bare ? children : <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><TodoPage /></Protected>} />
            <Route path="/protokolle" element={<Protected><ProtokollePage /></Protected>} />
            <Route path="/temperatur" element={<Protected><TemperaturPage /></Protected>} />
            <Route path="/erhitzung" element={<Protected><ErhitzungPage /></Protected>} />
            <Route path="/wareneingang" element={<Protected><WareneingangPage /></Protected>} />
            <Route path="/vorfaelle" element={<Protected><VorfaellePage /></Protected>} />
            <Route path="/dokumente" element={<Protected><DokumentePage /></Protected>} />
            <Route path="/schulungen" element={<Protected><SchulungenPage /></Protected>} />
            <Route path="/schulung-druck/:id" element={<Protected bare><SchulungPrint /></Protected>} />
            <Route path="/raeume" element={<Protected><RaeumePage /></Protected>} />
            <Route path="/einstellungen" element={<Protected><EinstellungenPage /></Protected>} />
            <Route path="/backfill" element={<Protected><BackfillPage /></Protected>} />
            <Route path="/export" element={<Protected><ExportPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
